import {CookiePolicy} from "./cookie-policy";
import {expireCookie, setCookie} from "../../umbrella-common/common-functions";
import {environment} from "../../../environments/environment";


export class FakeCookiePolicyService implements CookiePolicy {

	handle(cookiesNames: string[], isAccepted: boolean): void {
		cookiesNames?.forEach(cookie => {
			if (isAccepted) {
				setCookie(cookie, '1', 365 * 100, "/");
			} else {
				expireCookie(cookie, environment.cookiesDomain)
			}
		});
	}
}
